import { useForm } from '@/Hooks/useFormWrapper';
import { CountryCode } from '@/Enums';
import { AddressModel } from '@/Models';
import { shippingLabelModalAsyncActions } from '@/ModalWindows/ShippingLabelModal/services';
import { salesPageActions } from '@/Pages/Sales/services';
import { AppDispatch } from '@/Redux/ConfigureStore';
import { useDispatch } from 'react-redux';
import { AddressValidationResultModel } from '@/Models/AddressValidationResultModel';

export type FormData = {
  originalHouseNo: string;
  originalStreet: string;
  originalAdditionalLine: string;
  originalCity: string;
  originalCountry: string;
  originalCountryCode: CountryCode;
  originalPostalCode: string;
  originalCompany: string;
  originalFirstName: string;
  originalLastName: string;
  originalEmail: string;
  originalPhone: string;

  suggestedHouseNo: string;
  suggestedStreet: string;
  suggestedAdditionalLine: string;
  suggestedCity: string;
  suggestedCountry: string;
  suggestedCountryCode: CountryCode;
  suggestedPostalCode: string;
  suggestedCompany: string;
  suggestedFirstName: string;
  suggestedLastName: string;
  suggestedEmail: string;
  suggestedPhone: string;
};

export const useAddressValidationForm = (currentConflict?: AddressValidationResultModel) => {
  const dispatch: AppDispatch = useDispatch();

  const methods = useForm<FormData>();

  const onSubmit = methods.handleSubmit((values) => {
    if (!currentConflict) return;

    const { orderId } = currentConflict;

    const appliedAddress: AddressModel = {
      additionalLine: values.suggestedAdditionalLine,
      city: values.suggestedCity,
      company: values.suggestedCompany,
      country: values.suggestedCountry,
      countryCode: values.suggestedCountryCode,
      email: values.suggestedEmail,
      firstName: values.suggestedFirstName,
      houseNo: values.suggestedHouseNo,
      lastName: values.suggestedLastName,
      phone: values.suggestedPhone,
      postalCode: values.suggestedPostalCode,
      street: values.suggestedStreet,
    };

    dispatch(shippingLabelModalAsyncActions.applyAddressChanges({ orderId, appliedAddress })).then((response: any) => {
      if (response.error) {
        return;
      }
      dispatch(salesPageActions.updateValidatedAddress({ orderId, appliedAddress }));
    });
  });

  return {
    methods,
    onSubmit,
  };
};
